module.exports = __webpack_public_path__ + "static/media/h-square.9576a77e.svg";